import styles from "./LineList.module.scss";

type LineRowProps = {
  title: string;
  value: string | null;
};

export const LineRow: RFC<LineRowProps> = ({ title, value }) => {
  return (
    <div className={styles.row}>
      <div className={styles.title}>{title}</div>
      <div className={styles.value}>{value}</div>
    </div>
  );
};
